import { AccountAnalysisStatus } from '@mutual-services/account-types'
import * as illustrations from '~/assets/illustrations'

type Illustration = keyof typeof illustrations
type BadgeType = 'error' | 'success' | 'info' | 'warning'

export const hasRequiredNewCustomerAccountStatus = (currentStatus: AccountAnalysisStatus) => {
  return currentStatus === AccountAnalysisStatus.INITIAL_ANALYSIS ||
    currentStatus === AccountAnalysisStatus.ANALYST_QUEUE
}

export const hasInitialAnalysisStatus = (currentStatus: AccountAnalysisStatus) => {
  return currentStatus === AccountAnalysisStatus.INITIAL_ANALYSIS
}

export const hasPreApprovedAccountStatus = (currentStatus: AccountAnalysisStatus) => {
  return currentStatus === AccountAnalysisStatus.PRE_APPROVED
}

export const hasRequiredDocumentationAccountStatus = (currentStatus: AccountAnalysisStatus) => {
  return currentStatus === AccountAnalysisStatus.PENDING_ALL_DOCUMENTATION
}

export const hasRequiredPendenciesAccountStatus = (currentStatus: AccountAnalysisStatus) => {
  return currentStatus === AccountAnalysisStatus.DOCUMENTATION_WITH_PENDENCIES ||
    currentStatus === AccountAnalysisStatus.DOCUMENTATION_PARTIALLY_PENDING
}

export const hasPendenciesInAnalysis = (currentStatus: AccountAnalysisStatus) => {
  return currentStatus === AccountAnalysisStatus.WAITING_FOR_ANALYSIS_POST_PENDENCIES
}

export const hasAnalysisAccountStatus = (currentStatus: AccountAnalysisStatus) => {
  return currentStatus === AccountAnalysisStatus.UNDER_ANALYSIS ||
    currentStatus === AccountAnalysisStatus.WAITING_FOR_ANALYSIS
}

export const hasApprovedAccountStatus = (currentStatus: AccountAnalysisStatus) => {
  return currentStatus === AccountAnalysisStatus.APPROVED
}

export const hasPendingCompleteDataStatus = (currentStatus: AccountAnalysisStatus) => {
  return currentStatus === AccountAnalysisStatus.PENDING_COMPLETE_DATA
}

export const hasDeniedAccountStatus = (currentStatus: AccountAnalysisStatus) => {
  return currentStatus === AccountAnalysisStatus.DENIED ||
    currentStatus === AccountAnalysisStatus.DENIED_POST_ANALYSIS
}

export const translateAnalysisStatus = (status: AccountAnalysisStatus) => {
  switch (status) {
    case AccountAnalysisStatus.ANALYST_QUEUE:
      return 'Em análise'
    case AccountAnalysisStatus.DENIED:
    case AccountAnalysisStatus.DENIED_POST_ANALYSIS:
      return 'Negado'
    case AccountAnalysisStatus.WAITING_FOR_ANALYSIS:
    case AccountAnalysisStatus.UNDER_ANALYSIS:
      return 'Em validação'
    case AccountAnalysisStatus.APPROVED:
      return 'Aprovado'
    default:
      return 'Em validação'
  }
}

export const getAnalysisStatusIllustration = (status: AccountAnalysisStatus): Illustration => {
  switch (status) {
    case AccountAnalysisStatus.ANALYST_QUEUE:
      return 'WomanWithTablet'
    case AccountAnalysisStatus.DENIED:
    case AccountAnalysisStatus.DENIED_POST_ANALYSIS:
      return 'ManWithError'
    case AccountAnalysisStatus.WAITING_FOR_ANALYSIS:
    case AccountAnalysisStatus.UNDER_ANALYSIS:
      return 'ManWithFiles'
    case AccountAnalysisStatus.APPROVED:
      return 'ManWithTablet'
    default:
      return 'ManWithFiles'
  }
}

export const getAnalysisFeedbackPageTitle = (status: AccountAnalysisStatus) => {
  switch (status) {
    case AccountAnalysisStatus.ANALYST_QUEUE:
    case AccountAnalysisStatus.INITIAL_ANALYSIS:
      return 'Estamos analisando sua solicitação, por favor aguarde'
    case AccountAnalysisStatus.DENIED:
    case AccountAnalysisStatus.DENIED_POST_ANALYSIS:
      return 'Sua solicitação de crédito foi negada :('
    case AccountAnalysisStatus.WAITING_FOR_ANALYSIS:
    case AccountAnalysisStatus.UNDER_ANALYSIS:
      return 'Estamos analisando sua documentação, por favor, aguarde!'
    case AccountAnalysisStatus.APPROVED:
      return 'Parabéns, sua solicitação de crédito foi aprovada!'
    default:
      return 'Estamos analisando sua solicitação, por favor aguarde'
  }
}

export const getAnalysisFeedbackPageBadgeType = (status: AccountAnalysisStatus): BadgeType => {
  switch (status) {
    case AccountAnalysisStatus.ANALYST_QUEUE:
    case AccountAnalysisStatus.INITIAL_ANALYSIS:
      return 'warning'
    case AccountAnalysisStatus.DENIED:
    case AccountAnalysisStatus.DENIED_POST_ANALYSIS:
      return 'error'
    case AccountAnalysisStatus.WAITING_FOR_ANALYSIS:
    case AccountAnalysisStatus.UNDER_ANALYSIS:
      return 'info'
    case AccountAnalysisStatus.APPROVED:
      return 'success'
    default:
      return 'info'
  }
}
